// these values should match the GA config
export const GA_SESSION_LENGTH = 30 * 60 * 1000; // 30min
export const TIME_ZONE_OFFSET = -4 * 60 * 60 * 1000; // -4h (Toronto)
